import { TipDetails, TipStatus } from "model/Tip";

export interface WorkerMonthlyRow {
  workerId: number;
  name: string;
  totalHours: number;
  swishAmount: number;
  manualAmount: number;
};

const getWorkerName = (w: TipDetails["workers"][number]) =>
  `${w.firstName ?? ""} ${w.lastName ?? ""}`.trim() || `Worker ${w.workerId}`;

const workTimeToHours = (workTime: string): number => {
  const [hh = "0", mm = "0", ss = "0"] = workTime.split(":");
  const h = Number(hh);
  const m = Number(mm);
  const s = Number(ss);
  if (![h, m, s].every(Number.isFinite)) return 0;
  return h + m / 60 + s / 3600;
};

export const buildMonthlyReport = (tips: TipDetails[]): WorkerMonthlyRow[] => {
  const map = new Map<number, WorkerMonthlyRow>();

  tips.forEach((tip) => {
    const isSwish = tip.status === TipStatus.Closed;
    const isManual = tip.status === TipStatus.ClosedManually;

    tip.workers.forEach((w) => {
      const row = map.get(w.workerId) ?? {
        workerId: w.workerId,
        name: getWorkerName(w),
        totalHours: 0,
        swishAmount: 0,
        manualAmount: 0,
      };

      row.totalHours += workTimeToHours(w.workTime);

      if (isSwish) row.swishAmount += w.tipAmount;
      if (isManual) row.manualAmount += w.tipAmount;

      map.set(w.workerId, row);
    });
  });

  return Array.from(map.values());
};
